import { CForm, CCol, CFormInput, CFormLabel, CFormSelect, CFormCheck } from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useLoading } from "../Loading";
import { Button } from "@mui/material";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import db, { storage } from "../../firebase/firebaseConfig";
import { useAuth } from "../../contexts/authContext";
import { doc, getDoc, Timestamp, updateDoc } from "firebase/firestore";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toZonedTime } from "date-fns-tz";

function EditPost() {

    const { setLoading } = useLoading();
    const [image, setImage] = useState();
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const origin = location?.state?.root|| false;
    const { id } = useParams();
    const [lostFoundData, setLostFoundData] = useState({
        petName: "",
        age: "",
        breed: "",
        colour: "",
        gender: "",
        location: "",
        size: "",
        status: "",
        adopterId: "",
    });
    const malaysiaStates = [
        "Johor",
        "Kedah",
        "Kelantan",
        "Malacca",
        "Negeri Sembilan",
        "Pahang",
        "Perak",
        "Perlis",
        "Penang",
        "Sabah",
        "Sarawak",
        "Selangor",
        "Terengganu",
        "Kuala Lumpur",
    ];

    const dogBreeds = [
        "Golden Retriever", "Labrador Retriever", "German Shepherd", "Poodle", "Beagle",
        "Rottweiler", "Shih Tzu", "Maltese", "Siberian Husky", "Doberman Pinscher",
        "Golden Doodle", "Pomeranian", "Yorkshire Terrier", "French Bulldog", "Dachshund",
        "Boxer", "Australian Shepherd", "Miniature Schnauzer", "Chihuahua", "Bulldog",
    ];

    const catBreeds = [
        "Persian", "Siamese", "Maine Coon", "British Shorthair", "Ragdoll",
        "Bengal", "Sphynx", "American Shorthair", "Scottish Fold", "Munchkin",
    ];

    const otherBreeds = [

        "Parakeet", "Canary", "Finch", "Syrian Hamster", "Dwarf Hamster", "Ball Python", "Corn Snake", "Chinchillas", 
        "Guinea Pigs", "Ferrets", "Turtles", "Rabbits", "Hedgehogs", "Sugar Gliders", "Macaws", "Cockatoos",
        "Lovebirds",  "Geckos", "Iguanas", "Bearded Dragons"

    ];

    useEffect(() => {
        if(!origin)
        {
            navigate('/my-posts');
        }
        const fetchData = async()=>{
            const lostFoundRef = doc(db, "LostFound", id);
            const lostFoundSnap = await getDoc(lostFoundRef);
            if(lostFoundSnap.exists())
            {
                setLostFoundData(lostFoundSnap.data());
                const initialPreference = [];
                if(lostFoundSnap.data().email!=="")
                {
                    initialPreference.push("email");
                }
                if (lostFoundSnap.data().phoneNumber !== "") {
                    initialPreference.push("phone");
                }
                setContactPreference(initialPreference);
                const imageRef = ref(storage, `LostFound/${lostFoundSnap.data().image}`);
                const url = await getDownloadURL(imageRef);
                setImage(url);
            }
            setLoading(false);
        }
       fetchData();
    }, [id]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file)); // Generate preview URL
            setLostFoundData({ ...lostFoundData, image: file });
        }
        else {
            setImage(""); // Generate preview URL
            setLostFoundData({ ...lostFoundData, image: "" });
        }
    };

    const [contactPreference, setContactPreference] = useState([]);

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;

        setContactPreference((prev) =>
            checked ? [...prev, value] : prev.filter((item) => item !== value)
        );
        console.log(contactPreference);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (contactPreference.length === 0) {
            alert("Please select at least one contact method."); 
            return;
        }
        if(!image)
            {
                alert("Please upload the image for pet.");
                return;
            }
        setLoading(true);
        try {


            let newFileName = lostFoundData.image;
            if (typeof lostFoundData.image === 'object') { 
            const fileExtension = lostFoundData.image.name.split('.').pop();
            newFileName = `${currentUser.uid}_${Date.now()}.${fileExtension}`;
            const storageRef = ref(storage, `LostFound/${newFileName}`);
            await uploadBytes(storageRef, lostFoundData.image);
            }
           const updatedData = { ...lostFoundData, image: newFileName };

            const adopterRef = doc(db, "Adopters", currentUser.uid);
            const adopterSnap = await getDoc(adopterRef);

            const zonedDate = toZonedTime(new Date(), 'Asia/Kuala_Lumpur');
            const formattedTime = Timestamp.fromDate(zonedDate);

            if(contactPreference.includes("email")&&contactPreference.includes("phone"))
            {
                const {email, phoneNumber} = adopterSnap.data();

                const lostFoundRef = doc(db, "LostFound", id); 
                await updateDoc(lostFoundRef, 
                { ...updatedData, adopterId: currentUser.uid, email: email, phoneNumber: phoneNumber });

            }
            else if(contactPreference.includes("phone"))
            {
                const {phoneNumber} = adopterSnap.data();

                const lostFoundRef = doc(db, "LostFound", id); 
                await updateDoc(lostFoundRef, 
                { ...updatedData, adopterId: currentUser.uid,  phoneNumber: phoneNumber, email:"" });
            }
            else 
            {
                const {email} = adopterSnap.data();

                const lostFoundRef = doc(db, "LostFound", id);
                await updateDoc(lostFoundRef, 
                { ...updatedData, adopterId: currentUser.uid, email: email, phoneNumber:"" });
            }
            
            setLoading(false);
            alert("Edited Successfully")
            navigate('/my-posts', {replace:true});

            window.history.pushState(null, "", window.location.href);
            window.onpopstate = function(){
                window.history.pushState(null, "", window.location.href);
            }

        }
        catch (error) {
            setLoading(false);
            console.error(error);
        }

    };

    return (
        <div className="newPostContainer">
            <h1>Edit Post</h1>
            <div className="postForm">
                <CForm className="row g-3" onSubmit={handleSubmit}>
                    <CCol md={12}>
                        <CFormLabel htmlFor="inputName" className="formLabel">Pet Name</CFormLabel>
                        <CFormInput id="inputName" value={lostFoundData.petName} required
                            onChange={(e) => setLostFoundData({ ...lostFoundData, petName: e.target.value })} />
                    </CCol>
                    <CCol md={12}>
                        <CFormLabel htmlFor="inputType" className="formLabel">Pet Type</CFormLabel>
                        <CFormSelect id="inputType" value={lostFoundData.petType} required
                            onChange={(e) => setLostFoundData({ ...lostFoundData, petType: e.target.value })}>
                            <option value="">Choose...</option>
                            <option value="Dog">Dog</option>
                            <option value="Cat">Cat</option>
                            <option value="Other">Other</option>
                        </CFormSelect>
                    </CCol>
                    <CCol md={12}>
                        <CFormLabel htmlFor="inputBreed" className="formLabel">Breed</CFormLabel>
                        <CFormSelect
                            id="inputBreed"
                            value={lostFoundData.breed}
                            required
                            onChange={(e) => setLostFoundData({ ...lostFoundData, breed: e.target.value })}>
                            <option value="">Choose...</option>
                            {lostFoundData.petType === 'Dog' && dogBreeds.map((breed) => (
                                <option key={breed} value={breed}>{breed}</option>
                            ))}
                            {lostFoundData.petType === 'Cat' && catBreeds.map((breed) => (
                                <option key={breed} value={breed}>{breed}</option>
                            ))}
                            {lostFoundData.petType === 'Other' && otherBreeds.map((breed) => (
                                <option key={breed} value={breed}>{breed}</option>
                            ))}
                        </CFormSelect>
                    </CCol>
                    <CCol md={12}>
                        <CFormLabel htmlFor="inputColour" className="formLabel">Colour</CFormLabel>
                        <CFormSelect id="inputColour" value={lostFoundData.colour} required
                            onChange={(e) => setLostFoundData({ ...lostFoundData, colour: e.target.value })}>
                            <option value="">Choose...</option>
                            <option value="Black">Black</option>
                            <option value="Gray">Gray</option>
                            <option value="White">White</option>
                            <option value="Green">Green</option>
                            <option value="Cream">Cream</option>
                            <option value="Gold">Gold</option>
                            <option value="Orange">Orange</option>
                            <option value="Beige">Beige</option>
                        </CFormSelect>
                    </CCol>
                    <CCol md={12}>
                        <CFormLabel htmlFor="inputStatus" className="formLabel">Status</CFormLabel>
                        <CFormSelect id="inputStatus" value={lostFoundData.status} required
                            onChange={(e) => setLostFoundData({ ...lostFoundData, status: e.target.value })}>
                            <option value="">Choose...</option>
                            <option value="Lost">Lost</option>
                            <option value="Found">Found</option>
                            <option value="Completed">Completed</option>
                        </CFormSelect>
                    </CCol>
                    <CCol md={12}>
                        <CFormLabel htmlFor="inputLocation" className="formLabel">Location</CFormLabel>
                        <CFormSelect id="inputLocation" value={lostFoundData.location} required
                            onChange={(e) => setLostFoundData({ ...lostFoundData, location: e.target.value })}>
                            <option value="">Choose...</option>
                            {malaysiaStates.map(state => (
                                <option key={state} value={state}>{state}</option>
                            ))}
                        </CFormSelect>
                    </CCol>
                    <CCol md={12}>
                        <CFormLabel htmlFor="inputGender" className="formLabel">Gender</CFormLabel>
                        <CFormSelect id="inputGender" value={lostFoundData.gender} required
                            onChange={(e) => setLostFoundData({ ...lostFoundData, gender: e.target.value })}>
                            <option value="">Choose...</option>
                            <option value="Female">Female</option>
                            <option value="Male">Male</option>
                        </CFormSelect>
                    </CCol>

                    <CCol md={12}>
                        <CFormLabel htmlFor="inputAge" className="formLabel">Age</CFormLabel>
                        <CFormSelect id="inputAge" value={lostFoundData.age} required
                            onChange={(e) => setLostFoundData({ ...lostFoundData, age: e.target.value })}>
                            <option value="">Choose...</option>
                            <option value="Baby">Baby</option>
                            <option value="Young">Young</option>
                            <option value="Adult">Adult</option>
                            <option value="Senior">Senior</option>
                        </CFormSelect>
                    </CCol>
                    <CCol md={12}>
                        <CFormLabel htmlFor="inpuSize" className="formLabel">Size</CFormLabel>
                        <CFormSelect id="inputSize" value={lostFoundData.size} required
                            onChange={(e) => setLostFoundData({ ...lostFoundData, size: e.target.value })}>
                            <option value="">Choose...</option>
                            <option value="Baby">Baby</option>
                            <option value="Small">Small</option>
                            <option value="Medium">Medium</option>
                            <option value="Large">Large</option>
                        </CFormSelect>
                    </CCol>
                    <CCol md={12}>
                        <CFormLabel htmlFor="imageUpload" className="formLabel">Upload Profile Picture</CFormLabel>
                        <CFormInput type="file" id="imageUpload" accept="image/*" onChange={handleImageChange} />

                        {image && (
                            <div style={{ marginTop: "10px" }}>
                                <img src={image} alt="Preview" style={{ width: "150px", height: "150px", borderRadius: "10px", objectFit: "cover" }} />
                            </div>
                        )}
                    </CCol>
                    <CCol md={6}>
                        <CFormLabel className="formLabel">Preferred Contact Method</CFormLabel>
                        <div className="contact-checkbox">
                        <CFormCheck
                            type="checkbox"
                            id="contactEmail"
                            label="Email"
                            value="email"
                            onChange={handleCheckboxChange}
                            checked={contactPreference.includes("email")}
                        />

                        <CFormCheck
                            type="checkbox"
                            id="contactPhone"
                            label="Phone"
                            value="phone"
                            onChange={handleCheckboxChange}
                            checked={contactPreference.includes("phone")}
                        />
                        </div>
                    </CCol>
                    <CCol md={12}>
                        <Button type="submit" className="postBtn">Save</Button>
                    </CCol>
                </CForm>
            </div>
        </div>
    );
}

export default EditPost;